// import React, { useState, useEffect } from 'react';
// import { Card, Form, Button, Table, Alert, Spinner } from 'react-bootstrap';
// import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { authHeader } from '../services/auth-header';
// import { BASE_URL } from '../services/Api';
// import { useNavigate, useLocation } from 'react-router-dom';

// const StockReport = () => {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [reportGenerated, setReportGenerated] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
//     const [warehouseId, setWarehouseId] = useState('');
//     const [selectedBrand, setSelectedBrand] = useState('');

//     // State for dropdown options
//     const [warehouses, setWarehouses] = useState([]);
//     const [brandOptions, setBrandOptions] = useState([]);
//     const [loadingWarehouses, setLoadingWarehouses] = useState(true);
//     const [loadingBrands, setLoadingBrands] = useState(true);

//     // State for API data and loading
//     const [apiData, setApiData] = useState({
//         content: [],
//         pageNumber: 0,
//         pageSize: 10,
//         totalElements: 0,
//         totalPages: 0,
//         last: true
//     });
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     // State for sorting
//     const [sort, setSort] = useState({
//         field: 'productid',
//         direction: 'asc'
//     });

//     // Page size options
//     const pageSizeOptions = [
//         { value: 5, label: '5' },
//         { value: 10, label: '10' },
//         { value: 20, label: '20' },
//         { value: 50, label: '50' }
//     ];

//     // Initialize state from navigation if coming back
//     useEffect(() => {
//         // Check if we're coming back from details page
//         if (location.state?.reportState) {
//             const { reportState } = location.state;
//             setFromDate(reportState.fromDate);
//             setToDate(reportState.toDate);
//             setWarehouseId(reportState.warehouseId);
//             setSelectedBrand(reportState.selectedBrand);
//             setApiData(reportState.apiData);
//             setSort(reportState.sort);
//             setReportGenerated(true);
//         } else {
//             // Normal initialization
//             const fetchInitialData = async () => {
//                 try {
//                     setLoadingWarehouses(true);
//                     setLoadingBrands(true);

//                     // Fetch warehouses
//                     const warehouseResponse = await axios.get(BASE_URL + 'warehouse/findAllWarehouse', {
//                         headers: authHeader()
//                     });
//                     setWarehouses(warehouseResponse.data);
//                     if (warehouseResponse.data.length > 0) {
//                         setWarehouseId(warehouseResponse.data[0].id);
//                     }

//                     // Fetch brands
//                     const brandResponse = await axios.get(BASE_URL + 'brand/findAllBrand', {
//                         headers: authHeader()
//                     });
//                     setBrandOptions(brandResponse.data.map(brand => ({
//                         value: brand.id,
//                         label: brand.brandname
//                     })));
//                 } catch (err) {
//                     setError('Failed to load initial data');
//                     console.error('Error fetching initial data:', err);
//                 } finally {
//                     setLoadingWarehouses(false);
//                     setLoadingBrands(false);
//                 }
//             };

//             fetchInitialData();
//         }
//     }, [location.state]);

//     const handleProductClick = (productId) => {
//         if (!reportGenerated) {
//             setError('Please generate the report first by clicking "Generate Report"');
//             return;
//         }

//         navigate('/stock-details-quantity', {
//             state: {
//                 productId,
//                 fromDate,
//                 toDate,
//                 warehouseId,
//                 warehouseName: warehouses.find(w => w.id === warehouseId)?.warehousename,
//                 brandId: selectedBrand,
//                 brandName: brandOptions.find(b => b.value === selectedBrand)?.label,
//                 reportState: {
//                     fromDate,
//                     toDate,
//                     warehouseId,
//                     selectedBrand,
//                     apiData,
//                     sort
//                 }
//             }
//         });
//     };

//     // Fetch warehouses and brands on component mount
//     useEffect(() => {
//         const fetchInitialData = async () => {
//             try {
//                 setLoadingWarehouses(true);
//                 setLoadingBrands(true);

//                 // Fetch warehouses
//                 const warehouseResponse = await axios.get(BASE_URL + 'warehouse/findAllWarehouse', {
//                     headers: authHeader()
//                 });
//                 setWarehouses(warehouseResponse.data);
//                 if (warehouseResponse.data.length > 0) {
//                     setWarehouseId(warehouseResponse.data[0].id);
//                 }

//                 // Fetch brands
//                 const brandResponse = await axios.get(BASE_URL + 'brand/findAllBrand', {
//                     headers: authHeader()
//                 });
//                 setBrandOptions(brandResponse.data.map(brand => ({
//                     value: brand.id,
//                     label: brand.brandname
//                 })));
//             } catch (err) {
//                 setError('Failed to load initial data');
//                 console.error('Error fetching initial data:', err);
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Error',
//                     text: 'Failed to load initial data. Please try again.',
//                 });
//             } finally {
//                 setLoadingWarehouses(false);
//                 setLoadingBrands(false);
//             }
//         };

//         fetchInitialData();
//     }, []);

//     // Function to fetch stock report data
//     const fetchStockReport = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             // Construct query parameters
//             const params = new URLSearchParams({
//                 pageNumber: apiData.pageNumber,
//                 pageSize: apiData.pageSize,
//                 field: sort.field,
//                 direction: sort.direction,
//                 wid: warehouseId,
//                 fromdate: fromDate,
//                 todate: toDate,
//                 bid: selectedBrand || ''
//             });

//             // API call
//             const response = await axios.get(
//                 `${BASE_URL}stockreport/stockreport?${params}`,
//                 { headers: authHeader() }
//             );

//             setApiData(response.data);
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || 'Failed to fetch stock report');
//             console.error('Error fetching stock report:', err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Form submit handler
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (!fromDate || !toDate) {
//             setError('Please select both from and to dates');
//             return;
//         }
//         if (!warehouseId) {
//             setError('Please select a warehouse');
//             return;
//         }
//         setReportGenerated(true);
//         setApiData(prev => ({ ...prev, pageNumber: 0 }));
//         fetchStockReport();
//     };

//     // Page size handler
//     const handlePageSizeChange = (e) => {
//         const newSize = parseInt(e.target.value);
//         setApiData(prev => ({
//             ...prev,
//             pageSize: newSize,
//             pageNumber: 0
//         }));
//     };

//     // Sort handler
//     const handleSort = (field) => {
//         const newDirection = sort.field === field && sort.direction === 'asc' ? 'desc' : 'asc';
//         setSort({
//             field,
//             direction: newDirection
//         });
//         setApiData(prev => ({ ...prev, pageNumber: 0 }));
//     };

//     // Pagination handlers
//     const handlePageChange = (page) => {
//         setApiData(prev => ({ ...prev, pageNumber: page }));
//     };

//     const handlePreviousPage = () => {
//         if (apiData.pageNumber > 0) {
//             setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber - 1 }));
//         }
//     };

//     const handleNextPage = () => {
//         if (!apiData.last) {
//             setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
//         }
//     };

//     // Render pagination numbers
//     const renderPagination = () => {
//         const totalPages = apiData.totalPages;
//         const currentPage = apiData.pageNumber;
//         const siblingsCount = 2;
//         const firstPage = 0;
//         const lastPage = totalPages - 1;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button
//                     key={firstPage}
//                     className={`stock-page-btn ${currentPage === firstPage ? 'active' : ''}`}
//                     onClick={() => handlePageChange(firstPage)}
//                 >
//                     {firstPage + 1}
//                 </button>
//             );
//             if (startPage > firstPage + 2) {
//                 pageNumbers.push(<span key="dots-start" className="stock-page-dots">...</span>);
//             }
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`stock-page-btn ${currentPage === i ? 'active' : ''}`}
//                     onClick={() => handlePageChange(i)}
//                 >
//                     {i + 1}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             if (endPage < lastPage - 2) {
//                 pageNumbers.push(<span key="dots-end" className="stock-page-dots">...</span>);
//             }
//             pageNumbers.push(
//                 <button
//                     key={lastPage}
//                     className={`stock-page-btn ${currentPage === lastPage ? 'active' : ''}`}
//                     onClick={() => handlePageChange(lastPage)}
//                 >
//                     {lastPage + 1}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     // Fetch data when filters, pagination or sorting changes
//     useEffect(() => {
//         if (warehouseId && reportGenerated) {
//             fetchStockReport();
//         }
//     }, [apiData.pageNumber, apiData.pageSize, sort.field, sort.direction, warehouseId, selectedBrand]);

//     return (
//         <Card className="mt-4 stock-card">
//             <Card.Header className="stock-header">
//                 <h4 className="mb-0">Stock Details Report-Quantity</h4>
//             </Card.Header>

//             <Card.Body>
//                 {/* Filter Form */}
//                 <Form onSubmit={handleSubmit}>
//                     <div className="row mb-4">
//                         <div className="col-md-4">
//                             <Form.Group controlId="fromDate">
//                                 <Form.Label>From Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={fromDate}
//                                     onChange={(e) => setFromDate(e.target.value)}
//                                     required
//                                 />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-4">
//                             <Form.Group controlId="toDate">
//                                 <Form.Label>To Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={toDate}
//                                     onChange={(e) => setToDate(e.target.value)}
//                                     min={fromDate}
//                                     required
//                                 />
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-4">
//                             <Form.Group controlId="warehouse">
//                                 <Form.Label>Warehouse</Form.Label>
//                                 {loadingWarehouses ? (
//                                     <Form.Control as="div">
//                                         <Spinner animation="border" size="sm" /> Loading...
//                                     </Form.Control>
//                                 ) : (
//                                     <Form.Control
//                                         as="select"
//                                         value={warehouseId}
//                                         onChange={(e) => setWarehouseId(e.target.value)}
//                                         required
//                                     >
//                                         {warehouses.map(warehouse => (
//                                             <option key={warehouse.id} value={warehouse.id}>
//                                                 {warehouse.warehousename || `Warehouse ${warehouse.id}`}
//                                             </option>
//                                         ))}
//                                     </Form.Control>
//                                 )}
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-4">
//                             <Form.Group controlId="brand">
//                                 <Form.Label>Brand</Form.Label>
//                                 {loadingBrands ? (
//                                     <Form.Control as="div">
//                                         <Spinner animation="border" size="sm" /> Loading...
//                                     </Form.Control>
//                                 ) : (
//                                     <Form.Control
//                                         as="select"
//                                         value={selectedBrand}
//                                         onChange={(e) => setSelectedBrand(e.target.value)}
//                                     >
//                                         <option value="">All Brands</option>
//                                         {brandOptions.map(brand => (
//                                             <option key={brand.value} value={brand.value}>
//                                                 {brand.label}
//                                             </option>
//                                         ))}
//                                     </Form.Control>
//                                 )}
//                             </Form.Group>
//                         </div>

//                         <div className="col-md-4 d-flex align-items-end">
//                             <Button
//                                 variant="primary"
//                                 type="submit"
//                                 disabled={loading || loadingWarehouses || loadingBrands}
//                                 className="w-100"
//                             >
//                                 {loading ? (
//                                     <>
//                                         <Spinner as="span" animation="border" size="sm" className="me-2" />
//                                         Loading...
//                                     </>
//                                 ) : 'Generate Report'}
//                             </Button>
//                         </div>
//                     </div>
//                 </Form>

//                 <hr />

//                 {/* Error Alert */}
//                 {error && (
//                     <Alert variant="danger" onClose={() => setError(null)} dismissible>
//                         {error}
//                     </Alert>
//                 )}

//                 {/* Results Table */}
//                 {apiData.content.length > 0 ? (
//                     <>
//                         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingBottom: '10px' }}>
//                             <div className="stock-entries-control">
//                                 <span className="stock-entries-label">Show entries:</span>
//                                 <Form.Select
//                                     className="stock-entries-select"
//                                     onChange={handlePageSizeChange}
//                                     value={apiData.pageSize}
//                                     disabled={loading}
//                                     style={{ width: '100px', display: 'inline-block' }}
//                                 >
//                                     {pageSizeOptions.map((item) => (
//                                         <option key={item.value} value={item.value}>{item.label}</option>
//                                     ))}
//                                 </Form.Select>
//                             </div>
//                         </div>

//                         <div className="table-responsive">
//                             <Table striped bordered hover className="mb-0">
//                                 <thead className="bg-light">
//                                     <tr>
//                                         <th>#</th> {/* Index number column */}
//                                         <th onClick={() => handleSort('productid')} style={{ cursor: 'pointer' }}>
//                                             Product ID
//                                             {sort.field === 'productid' && (
//                                                 <span className="ms-2">
//                                                     {sort.direction === 'asc' ? '↑' : '↓'}
//                                                 </span>
//                                             )}
//                                         </th>
//                                         <th>Product Name</th>
//                                         <th>Part Number</th>
//                                         <th>Opening Qty</th>
//                                         <th>Inward Qty</th>
//                                         <th>Outward Qty</th>
//                                         <th>Closing Qty</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {apiData.content.map((item, index) => (
//                                         <tr key={item.productid}>
//                                             <td>{index + 1}</td> {/* Index number shown here */}
//                                             <td>
//                                                 <button
//                                                     className="btn btn-link p-10px text-white"
//                                                     onClick={() => handleProductClick(item.productid)}
//                                                 >
//                                                     {item.productid}
//                                                 </button>
//                                             </td>
//                                             <td>{item.productname || 'N/A'}</td>
//                                             <td>{item.partno || '-'}</td>
//                                             <td>{item.osqty ?? '0'}</td>
//                                             <td>{item.inwardqty ?? '0'}</td>
//                                             <td>{item.outwardqty ?? '0'}</td>
//                                             <td>{item.closingqty ?? '0'}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                         {/* Pagination Controls */}
//                         <div className="stock-pagination">
//                             <span className="stock-pagination-info">
//                                 Showing {apiData.content.length} of {apiData.totalElements} entries
//                             </span>
//                             <div className="stock-pagination-controls">
//                                 <button
//                                     className={`brand-pagination-btn ${apiData.pageNumber === 0 ? 'disabled' : ''}`}
//                                     onClick={handlePreviousPage}
//                                     disabled={apiData.pageNumber === 0 || loading}
//                                 >
//                                     <IoIosArrowBack />
//                                 </button>
//                                 <div className="stock-pagination-pages">
//                                     {renderPagination()}
//                                 </div>
//                                 <button
//                                     className={`brand-pagination-btn ${apiData.last ? 'disabled' : ''}`}
//                                     onClick={handleNextPage}
//                                     disabled={apiData.last || loading}
//                                 >
//                                     <IoIosArrowForward />
//                                 </button>
//                             </div>
//                         </div>
//                     </>
//                 ) : (
//                     !loading && (
//                         <div className="text-center py-5">
//                             <h5>No stock data available</h5>
//                             <p className="text-muted">Select filters and click "Generate Report"</p>
//                         </div>
//                     )
//                 )}
//             </Card.Body>
//         </Card>
//     );
// };

// export default StockReport;





import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Table, Alert, Spinner } from 'react-bootstrap';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import axios from 'axios';
import Swal from 'sweetalert2';
import { authHeader } from '../services/auth-header';
import { BASE_URL } from '../services/Api';
import { useNavigate, useLocation } from 'react-router-dom';

const StockReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [reportGenerated, setReportGenerated] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [warehouseId, setWarehouseId] = useState('');
    const [selectedBrand, setSelectedBrand] = useState('');

    // State for dropdown options
    const [warehouses, setWarehouses] = useState([]);
    const [brandOptions, setBrandOptions] = useState([]);
    const [loadingWarehouses, setLoadingWarehouses] = useState(true);
    const [loadingBrands, setLoadingBrands] = useState(true);

    // State for API data and loading
    const [apiData, setApiData] = useState({
        content: [],
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
        last: true
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // State for sorting
    const [sort, setSort] = useState({
        field: 'productid',
        direction: 'asc'
    });

    // Page size options
    const pageSizeOptions = [
        { value: 5, label: '5' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' }
    ];

    // Fetch warehouses and brands on component mount
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setLoadingWarehouses(true);
                setLoadingBrands(true);

                // Fetch warehouses
                const warehouseResponse = await axios.get(BASE_URL + 'warehouse/findAllWarehouse', {
                    headers: authHeader()
                });
                setWarehouses(warehouseResponse.data);
                if (warehouseResponse.data && warehouseResponse.data.length > 0) {
                    setWarehouseId(warehouseResponse.data[0].id);
                }

                // Fetch brands
                const brandResponse = await axios.get(BASE_URL + 'brand/findAllBrand', {
                    headers: authHeader()
                });
                if (brandResponse.data) {
                    setBrandOptions(brandResponse.data.map(brand => ({
                        value: brand.id,
                        label: brand.brandname
                    })));
                }
            } catch (err) {
                setError('Failed to load initial data');
                console.error('Error fetching initial data:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to load initial data. Please try again.',
                });
            } finally {
                setLoadingWarehouses(false);
                setLoadingBrands(false);
            }
        };

        fetchInitialData();
    }, []);

    // Initialize state from navigation if coming back
    useEffect(() => {
        // Check if we're coming back from details page
        if (location.state?.reportState) {
            const { reportState } = location.state;
            setFromDate(reportState.fromDate || '');
            setToDate(reportState.toDate || '');
            setWarehouseId(reportState.warehouseId || '');
            setSelectedBrand(reportState.selectedBrand || '');

            // Ensure apiData has the correct structure with content array
            if (reportState.apiData) {
                setApiData({
                    ...reportState.apiData,
                    content: reportState.apiData.content || [],
                    pageNumber: reportState.apiData.pageNumber || 0,
                    pageSize: reportState.apiData.pageSize || 10,
                    totalElements: reportState.apiData.totalElements || 0,
                    totalPages: reportState.apiData.totalPages || 0,
                    last: reportState.apiData.last !== undefined ? reportState.apiData.last : true
                });
            }

            setSort(reportState.sort || { field: 'productid', direction: 'asc' });
            setReportGenerated(true);
        }
    }, [location.state]);

    const handleProductClick = (productId) => {
        if (!reportGenerated) {
            setError('Please generate the report first by clicking "Generate Report"');
            return;
        }

        navigate('/stock-details-quantity', {
            state: {
                productId,
                fromDate,
                toDate,
                warehouseId,
                warehouseName: warehouses.find(w => w.id === warehouseId)?.warehousename,
                brandId: selectedBrand,
                brandName: brandOptions.find(b => b.value === selectedBrand)?.label,
                reportState: {
                    fromDate,
                    toDate,
                    warehouseId,
                    selectedBrand,
                    apiData,
                    sort
                }
            }
        });
    };

    // Function to fetch stock report data
    const fetchStockReport = async () => {
        try {
            setLoading(true);
            setError(null);

            // Construct query parameters
            const params = new URLSearchParams({
                pageNumber: apiData.pageNumber || 0,
                pageSize: apiData.pageSize || 10,
                field: sort.field,
                direction: sort.direction,
                wid: warehouseId,
                fromdate: fromDate,
                todate: toDate,
                bid: selectedBrand || ''
            });

            // API call
            const response = await axios.get(
                `${BASE_URL}stockreport/stockreport?${params}`,
                { headers: authHeader() }
            );

            // Ensure response has the correct structure
            setApiData({
                content: response.data?.content || [],
                pageNumber: response.data?.pageNumber || 0,
                pageSize: response.data?.pageSize || 10,
                totalElements: response.data?.totalElements || 0,
                totalPages: response.data?.totalPages || 0,
                last: response.data?.last !== undefined ? response.data.last : true
            });
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to fetch stock report');
            console.error('Error fetching stock report:', err);
            // Set empty content on error to prevent further errors
            setApiData(prev => ({
                ...prev,
                content: [],
                totalElements: 0,
                totalPages: 0,
                last: true
            }));
        } finally {
            setLoading(false);
        }
    };

    // Form submit handler
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!fromDate || !toDate) {
            setError('Please select both from and to dates');
            return;
        }
        if (!warehouseId) {
            setError('Please select a warehouse');
            return;
        }
        setReportGenerated(true);
        setApiData(prev => ({ ...prev, pageNumber: 0 }));
        // Small timeout to ensure state update
        setTimeout(() => {
            fetchStockReport();
        }, 0);
    };

    // Page size handler
    const handlePageSizeChange = (e) => {
        const newSize = parseInt(e.target.value);
        setApiData(prev => ({
            ...prev,
            pageSize: newSize,
            pageNumber: 0
        }));
    };

    // Sort handler
    const handleSort = (field) => {
        const newDirection = sort.field === field && sort.direction === 'asc' ? 'desc' : 'asc';
        setSort({
            field,
            direction: newDirection
        });
        setApiData(prev => ({ ...prev, pageNumber: 0 }));
    };

    // Pagination handlers
    const handlePageChange = (page) => {
        setApiData(prev => ({ ...prev, pageNumber: page }));
    };

    const handlePreviousPage = () => {
        if (apiData.pageNumber > 0) {
            setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber - 1 }));
        }
    };

    const handleNextPage = () => {
        if (!apiData.last) {
            setApiData(prev => ({ ...prev, pageNumber: prev.pageNumber + 1 }));
        }
    };

    // Render pagination numbers
    const renderPagination = () => {
        const totalPages = apiData.totalPages || 0;
        const currentPage = apiData.pageNumber || 0;
        const siblingsCount = 2;
        const firstPage = 0;
        const lastPage = totalPages - 1;
        let pageNumbers = [];

        if (totalPages === 0) return pageNumbers;

        const startPage = Math.max(firstPage, currentPage - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button
                    key={firstPage}
                    className={`stock-page-btn ${currentPage === firstPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(firstPage)}
                >
                    {firstPage + 1}
                </button>
            );
            if (startPage > firstPage + 2) {
                pageNumbers.push(<span key="dots-start" className="stock-page-dots">...</span>);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`stock-page-btn ${currentPage === i ? 'active' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i + 1}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            if (endPage < lastPage - 2) {
                pageNumbers.push(<span key="dots-end" className="stock-page-dots">...</span>);
            }
            pageNumbers.push(
                <button
                    key={lastPage}
                    className={`stock-page-btn ${currentPage === lastPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(lastPage)}
                >
                    {lastPage + 1}
                </button>
            );
        }

        return pageNumbers;
    };

    // Fetch data when filters, pagination or sorting changes
    useEffect(() => {
        if (warehouseId && reportGenerated && fromDate && toDate) {
            fetchStockReport();
        }
    }, [apiData.pageNumber, apiData.pageSize, sort.field, sort.direction]);

    return (
        <Card className="mt-4 stock-card">
            <Card.Header className="stock-header">
                <h4 className="mb-0">Stock Details Report-Quantity</h4>
            </Card.Header>

            <Card.Body>
                {/* Filter Form */}
                <Form onSubmit={handleSubmit}>
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <Form.Group controlId="fromDate">
                                <Form.Label>From Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    required
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-4">
                            <Form.Group controlId="toDate">
                                <Form.Label>To Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    min={fromDate}
                                    required
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-4">
                            <Form.Group controlId="warehouse">
                                <Form.Label>Warehouse</Form.Label>
                                {loadingWarehouses ? (
                                    <Form.Control as="div">
                                        <Spinner animation="border" size="sm" /> Loading...
                                    </Form.Control>
                                ) : (
                                    <Form.Control
                                        as="select"
                                        value={warehouseId}
                                        onChange={(e) => setWarehouseId(e.target.value)}
                                        required
                                    >
                                        <option value="">Select Warehouse</option>
                                        {warehouses.map(warehouse => (
                                            <option key={warehouse.id} value={warehouse.id}>
                                                {warehouse.warehousename || `Warehouse ${warehouse.id}`}
                                            </option>
                                        ))}
                                    </Form.Control>
                                )}
                            </Form.Group>
                        </div>

                        <div className="col-md-4">
                            <Form.Group controlId="brand">
                                <Form.Label>Brand</Form.Label>
                                {loadingBrands ? (
                                    <Form.Control as="div">
                                        <Spinner animation="border" size="sm" /> Loading...
                                    </Form.Control>
                                ) : (
                                    <Form.Control
                                        as="select"
                                        value={selectedBrand}
                                        onChange={(e) => setSelectedBrand(e.target.value)}
                                    >
                                        <option value="">All Brands</option>
                                        {brandOptions.map(brand => (
                                            <option key={brand.value} value={brand.value}>
                                                {brand.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                )}
                            </Form.Group>
                        </div>

                        <div className="col-md-4 d-flex align-items-end">
                            <Button
                                variant="primary"
                                type="submit"
                                disabled={loading || loadingWarehouses || loadingBrands}
                                className="w-100"
                            >
                                {loading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" className="me-2" />
                                        Loading...
                                    </>
                                ) : 'Generate Report'}
                            </Button>
                        </div>
                    </div>
                </Form>

                <hr />

                {/* Error Alert */}
                {error && (
                    <Alert variant="danger" onClose={() => setError(null)} dismissible>
                        {error}
                    </Alert>
                )}

                {/* Results Table */}
                {apiData?.content?.length > 0 ? (
                    <>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingBottom: '10px' }}>
                            <div className="stock-entries-control">
                                <span className="stock-entries-label">Show entries:</span>
                                <Form.Select
                                    className="stock-entries-select"
                                    onChange={handlePageSizeChange}
                                    value={apiData.pageSize}
                                    disabled={loading}
                                    style={{ width: '100px', display: 'inline-block' }}
                                >
                                    {pageSizeOptions.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <Table striped bordered hover className="mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th>#</th>
                                        <th onClick={() => handleSort('productid')} style={{ cursor: 'pointer' }}>
                                            Product ID
                                            {sort.field === 'productid' && (
                                                <span className="ms-2">
                                                    {sort.direction === 'asc' ? '↑' : '↓'}
                                                </span>
                                            )}
                                        </th>
                                        <th>Product Name</th>
                                        <th>Part Number</th>
                                        <th>Opening Qty</th>
                                        <th>Inward Qty</th>
                                        <th>Outward Qty</th>
                                        <th>Closing Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {apiData.content.map((item, index) => (
                                        <tr key={item.productid || index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <button
                                                    className="btn-product"
                                                    onClick={() => handleProductClick(item.productid)}
                                                >
                                                    {item.productid}
                                                </button>
                                            </td>
                                            <td>{item.productname || 'N/A'}</td>
                                            <td>{item.partno || '-'}</td>
                                            <td>{item.osqty ?? '0'}</td>
                                            <td>{item.inwardqty ?? '0'}</td>
                                            <td>{item.outwardqty ?? '0'}</td>
                                            <td>{item.closingqty ?? '0'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        {/* Pagination Controls */}
                        <div className="stock-pagination">
                            <span className="stock-pagination-info">
                                Showing {apiData?.content?.length || 0} of {apiData?.totalElements || 0} entries
                            </span>

                            <div className="stock-pagination-controls">
                                <button
                                    className={`brand-pagination-btn ${apiData.pageNumber === 0 ? 'disabled' : ''}`}
                                    onClick={handlePreviousPage}
                                    disabled={apiData.pageNumber === 0 || loading}
                                >
                                    <IoIosArrowBack />
                                </button>

                                <div className="stock-pagination-pages">
                                    {renderPagination()}
                                </div>

                                <button
                                    className={`brand-pagination-btn ${apiData.last ? 'disabled' : ''}`}
                                    onClick={handleNextPage}
                                    disabled={apiData.last || loading}
                                >
                                    <IoIosArrowForward />
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    !loading && (
                        <div className="text-center py-5">
                            <h5>No stock data available</h5>
                            <p className="text-muted">Select filters and click "Generate Report"</p>
                        </div>
                    )
                )}

                {/* Loading spinner when loading */}
                {loading && (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2">Loading stock report...</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default StockReport;